/** Treydora Legal Center route paths (single source of truth for links). */
export const LEGAL_PATHS = {
  center: "/legal",
  terms: "/legal/terms",
  privacy: "/legal/privacy",
  digitalAssetRisk: "/legal/digital-asset-risk",
  nftComicMerchLicense: "/legal/nft-comic-merch-license",
  vrRealEstateTerms: "/legal/vr-real-estate-terms",
  marketplaceSellerTerms: "/legal/marketplace-seller-terms",
  refundPolicy: "/legal/refund-policy",
  contentStandards: "/legal/content-standards",
};

export const LEGAL_DOC_SLUGS = Object.freeze([
  "terms",
  "privacy",
  "digital-asset-risk",
  "nft-comic-merch-license",
  "vr-real-estate-terms",
  "marketplace-seller-terms",
  "refund-policy",
  "content-standards",
]);
